import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUseDetails = () => {
  return (
    <>
      <section className='support-content ptb-120'>
        <div className='container'>
          <div className='row justify-content-between'>
            <div className='col-lg-12 col-md-8 p-lg-5'>
              <div className='support-article-wrap text-center'>
                <h1 className='display-5 mb-4 fw-bold'>
                  Terms of Use
                </h1>

                <div className='job-details-info my-5'>
                  <h3 className='h5'>
                    Terms of accessing and using our website
                  </h3>
                  <ul className='list-unstyled'>
                    <li>
                      Version 1.0, 12 August 2024
                    </li>
                  </ul>
                </div>
              </div>
              <div className='support-article-wrap'>
                <p>
                  These terms of use are intended for those accessing or using the Sunlex website, including all of its contents (the “website”).
                  This website is owned and operated by Sunlex ltd. (“we”, “us”, “our”), a company incorporated in England and Wales with a
                  registered office at Essell, 29 Howard Street, North Shields, Tyne And Wear, NE30 1AR, United Kingdom.
                </p>
              </div>
              <div className='support-article-wrap'>
                  <h4 className='h5 padding-top-10 padding-bottom-4'>
                    Accessing or using our website
                  </h4>
                  <p>
                    Our website is made available free of charge. We do not guarantee that our website, or any content on it, will always
                    be available uninterrupted. We may suspend, withdraw, discontinue or change all or any part of it without prior notice.
                    We will not be liable to you (“you”, “your”) if for any reason our website is unavailable at any time or for any period.
                  </p>
                  <p>
                    By accessing our website, you consent and agree to comply with the terms of use as set out below
                  </p>
                  <p>
                    IF YOU DO NOT AGREE TO THESE TERMS OF USE, PLEASE CEASE USING OUR WEBSITE IMMEDIATELY AND REFRAIN FROM ACCESS IN THE FUTURE.
                  </p>
                  <p>
                    These terms of use refer to the following additional terms as they also apply to your use of our website:
                  </p>
                  <ul className='content-list list-unstyled'>
                      <li>
                        our Privacy Policy which sets out our purposes for collection and processing of personal data and describes your rights in this connection;
                      </li>
                      <li>
                        our Cookie Policy which describes the cookies we use on our website.
                      </li>
                    </ul>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Changes to these terms of use
                      </h4>
                      <p>
                        We may revise these terms of use at our sole discretion with immediate effect by amending this page. We encourage
                        you to periodically review these terms as changes may be adopted from time to time. These terms of use were last
                        updated on August 12th, 2024.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Allowed use of the website and contents
                      </h4>
                      <p>
                        You hereby expressly acknowledge and agree that we are the owner or the licensee of all intellectual
                        property rights on our website, whereas all such materials are copyright protected.
                        The website and all its contents and functions are made available to you “as is” and “as available” for your
                        information and personal use only. Subject to your acceptance of and compliance with these terms of use, we grant
                        you a personal, non-commercial, revocable, non-exclusive, non-assignable right to use this website and its contents.
                      </p>
                      <p>
                        You agree that you will not use, copy, modify, adapt, distribute, transmit, display or otherwise exploit our
                        website or its contents for any other purpose whatsoever, unless with our prior written consent. You further agree
                        that you will not use any illustrations, photographs, video sequences or any graphics separately from any
                        accompanying text. You also agree that you will not remove, obscure or alter any copyright notice, trademark
                        or other proprietary rights notices affixed to or contained within this website or its contents. You are permitted
                        to download a copy or extracts of any page(s) from our website for your personal use only and you may draw the
                        attention of others to the contents of our website. Please make sure that the latter are made aware of these
                        terms of use.
                      </p>
                      <p>
                        Any misuse of this website and its contents contradictory to these terms of use or applicable law is strictly
                        prohibited and represents a violation of this agreement and intellectual property rights. Such misuse may therefore
                        lead to termination of your right to access or use this website and its contents, as well to legal action.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Information on this website
                      </h4>
                      <p>
                        You hereby acknowledge and agree that the content on our website is provided for general information only.
                        Although we make reasonable efforts to update the content regularly, we make no representations, warranties
                        or guarantees, whether express or implied, that the latter is comprehensive, accurate and up to date. You should
                        not rely on such information for business or legal decisions.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Viruses
                      </h4>
                      <p>
                        We do not guarantee that our website will be secure or free from bugs and viruses. You are responsible for
                        configuring your information technology, computer programmes and platform in order to access our website.
                        You should use your own protection software.
                      </p>
                      <p>
                        You must not misuse the website by knowingly introducing viruses, trojans, worms, logic bombs or other
                        material which is malicious or technologically harmful. You must not attempt to gain unauthorised access
                        to this website, the servers on which this website is stored or any server, computer or database connected
                        to this website. You must not attack our website via a denial-of-service attack or a distributed denial-of-service attack.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Links to third-party websites
                      </h4>
                      <p>
                        Where our website contains links to third-party websites or resources provided by third-parties, you acknowledge that
                        your access to or use of these websites and resources is entirely at your own discretion and at your own risk and
                        that you will be solely responsible for any loss or damage that may result from such access or use.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Disclaimer
                      </h4>
                      <p>
                        The website and any contents on it are made available to you on an “as is” and “as available” basis with no warranties whatsoever.
                        We and our affiliates, partners, licensors, suppliers and the respective directors, employees, agents and shareholders
                        (collectively referred to as the “Sunlex Parties”) do not assume any liability and disclaim any responsibility for any
                        consequences resulting from your access or use of this website and its contents.
                      </p>
                      <p>
                        The Sunlex Parties specifically and explicitly disclaim to the fullest extent permitted by law any and all representations,
                        guarantees and warranties, whether express or implied, with respect to this website and its contents, including, without limitation,
                        warranties to the accuracy, performance, merchantability, fitness for a particular purpose and non-infringement.
                      </p>
                      <p>
                        The Sunlex Parties also disclaim any warranties and liability regarding the accuracy, completeness, security, reliability,
                        timeliness and performance of this website and its contents.
                      </p>
                      <p>
                        Some countries and jurisdictions do now allow the exclusion or disclaimer of certain terms or warranties, so the above
                        exclusions in whole or in part may not apply fully to you. In such event, these exclusions shall apply to you to the extent
                        permitted by applicable law. You may also have other rights that vary from country to country and jurisdiction to jurisdiction.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Miscellaneous provisions
                      </h4>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Entire agreement
                      </h4>
                      <p>
                        These terms of use and any additional documents or policies constitute the entire agreement between you and
                        us and supersede and replace all prior understandings or agreements regarding the subject matter hereof.
                        Any waiver of any provision of these Terms of Use will be effective only if in writing and signed by us.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        No waiver
                      </h4>
                      <p>
                        Failure or delay by us to exercise any right, power or remedy under these terms of use or to require or enforce
                        strict performance by you of any provision of these terms of use, the Privacy and Cookie policy or any additional
                        document or policy, shall not amount to a waiver of any such right, power or remedy.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Severability
                      </h4>
                      <p>
                        All provisions of these terms of use are distinct and severable. If any provision of these terms of use is or
                        becomes invalid or unenforceable, the provision will be treated as if it was not in the agreement and the
                        remaining provisions will still be valid and enforceable.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Governing law and dispute resolution
                      </h4>
                      <p>
                        Although our website can be accessed from numerous places and countries around the world, that shall not be
                        construed as consent to abide by that local jurisdiction. Any relationship between you and us arising out of
                        these terms of use shall be governed by the laws of England and Wales.
                      </p>
                      <p>
                        All disputes, arising out of these terms of use or related to them, including those arising out of or concerning
                        its interpretation, invalidity, performance or termination, shall be referred for resolution to the competent
                        courts in England and Wales.
                      </p>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfUseDetails;
